import { NodeConfig } from '../types';

export const execute_actions: NodeConfig = {
  type: 'execute_actions'
};
